(function () {
  'use strict';

  function initCountdown(root) {
    var startRaw = root.getAttribute('data-start');
    var endRaw = root.getAttribute('data-end');
    var shopOffset = root.getAttribute('data-shop-timezone-offset') || '+0000';

    // Liquid gives us "now" formatted in the shop's local timezone already,
    // so we attach that same offset to the start/end strings to build
    // real, comparable Date objects (rather than assuming the visitor's
    // browser timezone matches the shop's).
    var offsetFormatted = shopOffset.slice(0, 3) + ':' + shopOffset.slice(3);

    var startDate = new Date(startRaw + offsetFormatted);
    var endDate = new Date(endRaw + offsetFormatted);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return;
    }

    var storageKey = 'countdown-ended-' + root.id;

    // If a previous visit already determined this countdown ended,
    // hide immediately without waiting on JS timing, so there's no
    // flash of the section before the check below would normally run.
    if (sessionStorage.getItem(storageKey) === 'true') {
      root.hidden = true;
      return;
    }

    var scheduleEl = root.querySelector('[data-countdown-schedule]');
    var activeEl = root.querySelector('[data-countdown-active]');
    var daysEl = root.querySelector('[data-days]');
    var hoursEl = root.querySelector('[data-hours]');
    var minutesEl = root.querySelector('[data-minutes]');
    var secondsEl = root.querySelector('[data-seconds]');

    var intervalId = null;

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function render() {
      var now = new Date();

      if (now < startDate) {
        // Not started yet: show the date range, hide the live numbers.
        scheduleEl.hidden = false;
        activeEl.hidden = true;
        return;
      }

      if (now >= endDate) {
        // Countdown finished: hide the whole section and remember
        // that decision for this browser session so future page
        // loads on this visit skip straight to hidden.
        root.hidden = true;
        sessionStorage.setItem(storageKey, 'true');
        if (intervalId) {
          clearInterval(intervalId);
        }
        return;
      }

      // In progress: show the live countdown.
      scheduleEl.hidden = true;
      activeEl.hidden = false;

      var diff = endDate.getTime() - now.getTime();
      var totalSeconds = Math.floor(diff / 1000);

      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    render();
    intervalId = setInterval(render, 1000);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-countdown]');
    sections.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when the section is added or edited live in the
  // theme editor, since Shopify replaces the section's HTML on
  // setting changes without a full page reload.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-countdown]');
    if (root) {
      initCountdown(root);
    }
  });
})();